import classNames from 'classnames';

export default function useClasses (...args) {
    return classNames(...args);
}